import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";

export default class TaskProjectedComDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        temp: this.props.dataItem[this.props.field],        
    };
  }
  componentDidMount = () => {
    
    try {
      let element = document.getElementsByClassName("k-dateinput")[0];
      if (element) {
        element.addEventListener("keydown", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Direct method to clear the date using the same structure as handleChange
  handleClear = () => {
    console.log("Clear button clicked");
    
    // Create an event object that mimics what the DatePicker would send
    const kendoEvent = {
      value: null,
      target: { value: null },
      syntheticEvent: {
        target: { value: null },
        preventDefault: () => {},
        stopPropagation: () => {}
      }
    };
    
    // Call handleChange with our custom event
    this.handleChange(kendoEvent);
  };

  handleChange = (e) => {    
    this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
      if (
        this.props.field &&
        this.props.field === this.props.dataItem.inEdit 
      ) {
        let updateData = {
          ...this.props.dataItem,
          [this.props.field]: e.value,
        };
        this.props.updateDropdownValue(updateData);
      }
  };
    
  handleEditCell = () => {
    if(( this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open" ) && (!this.props.isTask)){
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
      isOverdue = (dataValue) => {
          let currentdate = new Date();
          currentdate.setDate(currentdate.getDate() - 1);
          return (this.props.dataItem["isClosed"] == false ||
            this.props.dataItem["isClosed"] == null ||
            this.props.dataItem["isClosed"] == "Open") &&
            moment(dataValue).toDate() < currentdate
            ? "redCell"
            : "txtWhite";
        };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId=dataItem.ownerId;
    const dataValue = dataItem[field] === null || dataItem[field] == undefined ? "" : new Date(dataItem[field]);
    
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
            <td className="date-picker-cell">
        <div style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          width: "100%"
        }}>
          <DatePicker
            format="dd-MMM-yyyy"
            value={dataValue}
            onChange={this.handleChange.bind(this)}
            defaultShow={true}
            style={{
              width: "100%",
              paddingRight: "24px" // Make room for the clear button
            }}
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "right", vertical: "top" },
              appendTo: document.body, // Append the popup to the body
            }}
          />
          {dataValue && (
            <button
              type="button"
              onClick={this.handleClear}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "28px", // Position it just before the calendar icon
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                background: "transparent",
                border: "none",
                color: "#777",
                fontWeight: "bold",
                fontSize: "14px",
                width: "20px",
                height: "20px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%"
              }}
              title="Clear date"
            >
              ×
            </button>
          )}
        </div>
      </td>
      
            );
    } else {       
      if((loginUserId===ownerId)&&this.props.dataItem.isClosed===false){
        return (
          <td onClick={this.handleEditCell} className={this.isOverdue(dataValue)}>
            {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
          </td>
        )
      }else{ 
      return this.props.dataItem.roleName == "View Only"||this.props.dataItem.roleName == "Standard User"||this.props.dataItem.isClosed == true  ? (
        <td className={this.isOverdue(dataValue)}>
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      ) : (
        <td onClick={this.handleEditCell} className={this.isOverdue(dataValue)}>
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      );
      }
    }
  }
}
